import app, { Component } from 'apprun';
import { lookup_en } from '../utils';

export default class CommonPropertyComponent extends Component {
  view = (state) => {
    lookup_en.ExpertTopic.sort(function (a, b) {
      return a.value.toUpperCase() > b.value.toUpperCase() ? 1 : -1;
    });

    //console.log(state);
    if (!state || !state.newVal) {return;}

    //state.newVal.map(p => console.log(p.ExpertTopicName + ',' + p.ExpertTopicID));
    return (
      <div style={{ width: '400px' }}>
        <table>
          {state.newVal.map(p => (
            <tr>
              <td>
                {p.ExpertTopicName}&nbsp;
                <a class="btn btn-xs" onclick={() => this.run('delArea', p)}>
                  ✂
                </a>
              </td>
            </tr>
          ))}
        </table>
        <div>
          <select name="ExpertTopicSelection" id="ExpertTopicSelection" required="required">
            {lookup_en.ExpertTopic.map((r) => {
              return <option value={r.id}>{r.value}</option>;
            })}
          </select>
          &nbsp;
          <a type="edit-buttons" class="btn btn-primary btn-xs" onclick={() => this.run('addArea')}>
            add
          </a>
        </div>
        <br />
        <div class="edit-buttons">
          <a type="button" class="btn btn-primary btn-xs" onclick={() => this.run('save')}>
            save
          </a>
          <a type="button" class="btn btn-default btn-xs" onclick={() => state.caller.run(state.cancel, state.panelId)}>
            cancel
          </a>
        </div>
      </div>
    );
  };

  update = {
    refresh: (state, newState) => {
      return { ...state, ...newState, newVal: [...newState.item.value], options: [] };
    },

    save: (state) => {
      if (!state.newVal) {return;}
      state.caller.run(state.save, state.item, state.panelId, state.newVal);
    },

    delArea: (state, p) => {
      //console.log('In delArea...');
      state.newVal.splice(state.newVal.indexOf(p), 1);
      return state;
    },

    addArea: (state) => {
      const e = document.getElementById('ExpertTopicSelection') as HTMLSelectElement;
      const sel = e.selectedIndex;
      const opt = e.options[sel];
      const topicId = opt.value;
      const topicName = opt.text;

      state.newVal.push({ ExpertTopicID: topicId, ExpertTopicName: topicName });
      return state;
    }
  };

  mounted = ({ state }) => {
    this.run('refresh', state);
  };
}
